"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function hasContentInChildren(content, contentId) {
    return !!content.children.find((c) => c._id === contentId);
}
function getParentContentByContentId(content, contentId) {
    const modelType = content.modelType;
    switch (modelType) {
        case 'offer':
            if (hasContentInChildren(content, contentId)) {
                return content;
            }
            for (const childContent of content.children) {
                const foundChild = getParentContentByContentId(childContent, contentId);
                if (foundChild) {
                    return foundChild;
                }
            }
            return undefined;
        default:
            return null;
    }
}
exports.getParentContentByContentId = getParentContentByContentId;
//# sourceMappingURL=getParentContentByContentId.js.map